import { Button, Heading, ModalBody, ModalHeader, Select, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { REJECTION_REASONS } from '@views/RFITransactions/constants';
import { IoArrowBackOutline } from 'react-icons/io5';
import InputComponent from '@components/Input';


const RejectModal = ({ rejectionHeading, handleReject }) => {
  const [reason, setReason] = useState(null);
  const [customReason, setCustomReason] = useState();
  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };
  const handleCustomReasonChange = (e) => {
    setCustomReason(e.target.value);
  };
  const isDisabled = () => {
    if (!reason) return true;
    if (reason === REJECTION_REASONS.OTHER) return !customReason?.trim();
    return false;
  };

  return (
    <>
      <ModalHeader>
        <Heading size={'md'}>
          {`Rejection Reason for ${rejectionHeading}`}
        </Heading>
      </ModalHeader>
      <ModalBody pb={'2rem'}>
        <VStack alignItems={'start'} gap={4}>
          {reason !== REJECTION_REASONS.OTHER ? (
            <Select
              placeholder="Enter Rejection Reason"
              onChange={handleReasonChange}
            >
              {Object.keys(REJECTION_REASONS).map((reason) => (
                <option value={reason}>{reason}</option>
              ))}
            </Select>
          ) : (
            <InputComponent
              aria-label="Info"
              placeholder="Enter the reason for rejection"
              value={customReason}
              handleChange={handleCustomReasonChange}
              leftElementClickable={true}
              leftElement={
                <IoArrowBackOutline
                  onClick={() => {
                    setReason(null);
                    setCustomReason(null);
                  }}
                />
              }
              variant="brand"
              size="md"
            />
          )}
          <Button
            colorScheme="red"
            alignSelf="end"
            variant={'outline'}
            onClick={() => handleReject(reason === REJECTION_REASONS.OTHER ? customReason : reason)}
            isDisabled={isDisabled()}
          >
            Reject Information
          </Button>
        </VStack>
      </ModalBody>
    </>
  );
};

export default RejectModal;
